var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MyProjectsSection,{attrs:{"icon":"invoiceDraft","title":_setup.t('invoices.draft-invoices_USERTYPE'),"help-text":_setup.t('invoices.helptexts.draft_USERTYPE')}},[_c(_setup.InvoicesTable,{attrs:{"data":_setup.draftInvoices,"type":"draft"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }